import { render } from "./ProfileUpdate.vue?vue&type=template&id=52be320c&scoped=true&ts=true"
import script from "./ProfileUpdate.vue?vue&type=script&lang=ts"
export * from "./ProfileUpdate.vue?vue&type=script&lang=ts"

import "./ProfileUpdate.vue?vue&type=style&index=0&id=52be320c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52be320c"]])

export default __exports__